var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"margin-top":"30px"},attrs:{"fluid":"","tag":"section"}},[_c('v-row',[_c('v-col',[_c('eventsTable')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }